module.exports = __webpack_public_path__ + "img/Mask-group3.20d558fc.png";